import { useState, useEffect } from 'react'
import InstantMessageController from 'controller/InstantMessageController'

import MessageConversationCard from './MessageConversationCard'
import Util from 'service/util'
import Loading from 'component/Loading'

const MessageConversationList = ({
  refresher, wsState,
  onConversationSelected
}) =>
{
  const [filter, setFilter] = useState('')

  useEffect(() => {
    /* call to refresh */
  }, [refresher])

  
  const mapContactList = (contact) =>
  {
    const uid         = contact.details.uid
    const wa_id       = contact.details.wa_id
    const cid         = uid || wa_id
    const name        = contact.name
    const phoneNumber = contact.phoneNumber || wa_id

    const lastMsg     = contact.messages[0]
    const lastMessage = lastMsg
      ? lastMsg.message_type == 'text'
        ? lastMsg.text_body
        : lastMsg.message_type
      : '<沒有訊息>'
    const sentTime    = lastMsg
      ? Util.LongDate(lastMsg.sent_time)
      : ''
    const timestamp   = lastMsg
      ? new Date(lastMsg.sent_time).valueOf()
      : 0

    return {
      origin: contact,
      simple: { cid, wa_id, uid, phoneNumber, name, lastMessage, sentTime, timestamp }
    }
  }

  const sortContactList = (a, b) =>
  {
    if (a.timestamp > b.timestamp) return -1
    if (a.timestamp < b.timestamp) return -1
    return 0
  }

  const getFilteredContacts = () =>
  {
    let conversations = InstantMessageController.Conversations?.values().toArray() || []

    return conversations
      .filter(x => {
        if (!filter) return true

        const d = x.details
        if (-1 < String(d.id).indexOf(filter)) return true
        if (-1 < String(d.display_name).indexOf(filter)) return true
        if (d.vehicles) {
          for (let v of d.vehicles)
          {
            if (-1 < String(v.cd_license).indexOf(filter)) return true
          }
        }
        if (d.contacts)
        {
          for (let c of d.contacts)
          {
            if (-1 < String(c.c_name).indexOf(filter)) return true
            if (-1 < String(c.c_num).indexOf(filter)) return true
          }
        }

        return false
      })
      .map(mapContactList)
      .sort(sortContactList)
      .map(({origin, simple}) => <MessageConversationCard key={simple.cid} {...simple}
        onClick={_ => onConversationSelected(origin)} />)
  }

  return (
    <section className="message-contact-list">
      <div className="contact-list-head">
        <input className="contact-list-search" type="text"
          placeholder="搜尋姓名/電話/車牌/編號"
          value={filter} onChange={e => setFilter(e.target.value)} />
      </div>
      <div className="contact-list-body">
        { refresher == 0
          ? <Loading />
          : getFilteredContacts()
        }
      </div>
    </section>
  )
}

export default MessageConversationList
